function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('body [id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    let dropdownFacet = event.currentTarget.querySelector('.dropdown-menu__control');
    let getDropdownId = event.currentTarget.getAttribute('aria-controls');
    let summaryDropdown = document.getElementById(getDropdownId);
    let firstSelectedOption = summaryDropdown.querySelector('.facets__item input:checked');
    if(firstSelectedOption) {
      let summaryDropdownTop = summaryDropdown.getBoundingClientRect().top;
      let firstSelectedOptionTop = firstSelectedOption.getBoundingClientRect().top;
      event.currentTarget.closest('details').style.setProperty('--facets-dropdown-top', `-${firstSelectedOptionTop - summaryDropdownTop}px`)
    }
    if(dropdownFacet) {
      event.currentTarget.closest('details').style.setProperty('--facets-dropdown-width', `${dropdownFacet.getBoundingClientRect().width}px`)
    }

  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;


  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

class QuantityDropdownCustom extends HTMLElement {
  constructor() {
      super();
      this.dropdown = this.querySelector('.quantity-selector');
      this.inputVariantId = this.querySelector('.quantity-selector').getAttribute('data-input');
      this.inputElement = document.querySelector('#cart [data-quantity-variant-id="'+this.inputVariantId+'"]');
      this.inputParentElement = this.inputElement.parentElement;
      this.changeEvent = new Event('change', { bubbles: true });

      this.findAndPrepareDropdown();
    }
    findAndPrepareDropdown() {
      if(!document.getElementsByTagName('body')[0].classList.contains('template-cart')) {
        return false;
      }
      const _that = this;
      window.rkVariantInputs = window.rkVariantInputs || [];
      const variant_id = this.inputVariantId;
      if(window.rkVariantInputs.includes(variant_id)) return false;
      rkVariantInputs.push(variant_id);

      this.inputParentElement.classList.add("hidden");

      const dropdownButton = this.dropdown.querySelector('button');
      const dropdownList = dropdownButton.nextElementSibling;
      let selectedValue = 1;
      dropdownButton.addEventListener('click', (event) => {
          event.preventDefault();
          dropdownList.classList.toggle("hidden");
          _that.dropdown.classList.toggle("open");
      })
      dropdownList.addEventListener("click", function (e) {
        if (e.target.tagName === "LI") {
            selectedValue = e.target.dataset.value;
            dropdownButton.textContent = `x${selectedValue}`;
            dropdownList.classList.add("hidden");
            _that.dropdown.classList.toggle("open");
            _that.inputElement.value = selectedValue;
            _that.inputElement.dispatchEvent(_that.changeEvent)
          }
      });
      document.addEventListener("click", function (e) {
          if (!dropdownButton.contains(e.target) && !dropdownList.contains(e.target)) {
              dropdownList.classList.add("hidden");
              _that.dropdown.classList.toggle("open");
          }
      });
      window.rkVariantInputs = []; //reset for next render
  }
}
customElements.define('quantity-dropdown-custom', QuantityDropdownCustom);


function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

Shopify.getCurrentProductMetafields = function () {
  if( typeof product !== 'undefined' && 
      typeof window['variants_'+product.id] !== 'undefined' && 
      typeof currentVariant !== 'undefined' &&
      typeof window['variants_'+product.id][currentVariant.id] !== 'undefined'
    ) {
            return window['variants_'+product.id][currentVariant.id];
    }

    return false;
}


class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  setHeaderCssVariable() {
    setTimeout(() => {
      document.documentElement.style.setProperty('--fws-header-height', `${this.header.offsetHeight}px`);
    }, 350);
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.setHeaderCssVariable();

    this.header.classList.add('menu-open');
    document.querySelector('body').classList.add('main-nav--open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    document.querySelector('body').classList.remove('main-nav--open');
    window.removeEventListener('resize', this.onResize);
    this.setHeaderCssVariable();
  }  

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    this.setHeaderCssVariable();
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.color_has_multiple_lens = false;
    this.addEventListener('change', this.onVariantChange);
    this.updateOptions();
    this.updateMasterId();
    this.updateGallery();
    // this.clickTheSelctedColor();
    document.documentElement.style.setProperty('--varaint-selects-height', `${this.offsetHeight}px`);
    // Wait for DOMContentLoaded before correcting. This runs inside the element's
    // constructor, and global.js is deferred from theme.liquid while product-form.js is
    // deferred from the section - deferred scripts execute in document order, so
    // <product-form> has not been upgraded yet. Firing a change event now reaches
    // onVariantChange -> removeErrorMessage(), which calls productForm.handleErrorMessage()
    // on a element that is still a plain HTMLElement and throws, aborting the handler
    // before updateGallery() ever runs - so the size pill corrected while the dimensions
    // panel kept the old variant's numbers.
    if (document.readyState === 'loading' || document.readyState === 'interactive') {
      document.addEventListener('DOMContentLoaded', () => this.correctHiddenSizeSelection(), { once: true });
    } else {
      this.correctHiddenSizeSelection();
    }
  }

  // Shopify's search results deep-link ?variant=<id>, and the variant it picks can be one
  // whose size the picker hides (custom.hide_size_variant) - the shopper then lands on a
  // size they cannot see or click. snippets/rm-visible-variant-url.liquid rewrites those
  // links before they are clicked; this is the backstop for a link that was already shared,
  // bookmarked or indexed.
  //
  // Deliberately limited to arrivals from search. The hidden sizes still hold stock, so a
  // hidden variant reached any other way may be a link someone meant to send, and silently
  // moving the shopper off it would be worse than leaving it alone.
  correctHiddenSizeSelection() {
    const map = window.visibleVariantFor;
    if (!map || Object.keys(map).length === 0) return;

    const params = new URLSearchParams(window.location.search);
    const fromSearch = ['_ss', '_sid', '_pos', '_psq', '_psid'].some((key) => params.has(key));
    if (!fromSearch) return;

    const currentId = params.get('variant');
    if (!currentId) return;

    const replacementId = map[currentId];
    if (!replacementId) return;

    const replacement = this.getVariantData().find((variant) => variant.id == replacementId);
    if (!replacement) return;

    // Seat every option first and fire a SINGLE change afterwards. Dispatching per
    // option instead makes onVariantChange run against a half-updated picker, so
    // updateMasterId() matches no variant, currentVariant comes back undefined and
    // setUnavailable() strips the price and BUY button off the page.
    let primary = null;
    Array.from(this.querySelectorAll('select, fieldset')).forEach((element, index) => {
      const optionValue = replacement.options[index];
      if (optionValue === undefined) return;

      if (element.tagName === 'SELECT') {
        element.value = optionValue;
        if (!primary) primary = element;
        return;
      }

      const escaped = String(optionValue).replace(/(["\\])/g, '\\$1');
      let input = null;
      if (element.getAttribute('data-option') === 'color') {
        // A colour can appear once per lens, so the id disambiguates which swatch to check.
        input = element.querySelector(
          'input[type="radio"][data-variant-id="' + replacementId + '"][value="' + escaped + '"]'
        );
      }
      if (!input) {
        input = element.querySelector('input[type="radio"][value="' + escaped + '"]');
      }
      if (!input) return;
      input.checked = true;
      // Prefer a swatch carrying the variant id: dispatching from it reproduces a real
      // click, which is the path colorSwatchDefaultVariant() already knows how to handle.
      if (!primary || input.dataset.variantId === String(replacementId)) primary = input;
    });

    if (primary) primary.dispatchEvent(new Event('change', { bubbles: true }));

    params.set('variant', replacementId);
    window.history.replaceState({}, '', window.location.pathname + '?' + params.toString());
  }

  onVariantChange(event) {
    this.colorSwatchDefaultVariant(event);
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateGallery();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.playVimeoVideo();
      this.initFlickitySlider();
    }
    this.updateProductTitleBadge();
    this.updateRegionAvailability();
    // document.documentElement.style.setProperty('--varaint-selects-height', `${this.offsetHeight}px`);
  }

  // Region-based availability override (LA vs Provence routing).
  // Visibility (hiding ATC, showing the Sold Out / Notify Me modal-button) is handled
  // by updateGallery() above via the existing theme's effective-availability check,
  // and by the existing CSS rule `[data-submit-form][disabled], [data-oos-button][disabled] { display: none }`.
  // This method only handles the bits updateGallery doesn't: keeping the data-region-sold-out
  // attribute in sync and swapping the standard Shopify Add-to-Cart button text.
  updateRegionAvailability() {
    if (!this.currentVariant) return;
    if (typeof product === 'undefined' || !product || !product.id) return;
    if (typeof window['variants_' + product.id] === 'undefined') return;

    const variantData = window['variants_' + product.id][this.currentVariant.id];
    if (!variantData) return;

    const regionShowSoldOut = this.computeRegionOverrideForVariant(this.currentVariant);

    document.querySelectorAll('[data-region-buy-button]').forEach(btn => {
      btn.dataset.regionSoldOut = regionShowSoldOut ? 'true' : 'false';

      // Only swap text on the standard Shopify ATC button (snippets/buy-buttons.liquid).
      // Matsuda BUY buttons keep their BUY label — the adjacent rm-modal-button shows
      // "SOLD OUT | NOTIFY ME" when its <modal-button> wrapper has no hidden attribute.
      if (btn.classList.contains('product-form__submit')) {
        const textEl = btn.querySelector('[data-add-to-cart-text]');
        if (textEl) {
          textEl.textContent = regionShowSoldOut
            ? 'Sold Out'
            : this.getDefaultBuyText(btn, variantData);
        }
      }
    });

    // Sync disabled class on color swatch inputs for region-OOS variants.
    // Mirrors the Liquid logic in swatch-input.liquid so swatches stay accurate on variant change.
    document.querySelectorAll('[data-option="color"] .swatch-input__input').forEach(swatchInput => {
      const vid = parseInt(swatchInput.dataset.variantId, 10);
      if (!vid) return;
      const regionOOS = this.computeRegionOverrideForVariant({ id: vid });
      if (regionOOS) {
        swatchInput.classList.add('disabled');
      } else {
        const v = window.product && window.product.variants && window.product.variants.find(v => v.id === vid);
        if (v && v.available) swatchInput.classList.remove('disabled');
      }
    });
  }

  // Helper used by both updateGallery (for visibility) and updateRegionAvailability (for text).
  computeRegionOverrideForVariant(variant) {
    if (!variant) return false;
    if (typeof product === 'undefined' || !product || !product.id) return false;
    if (typeof window['variants_' + product.id] === 'undefined') return false;

    const variantData = window['variants_' + product.id][variant.id];
    if (!variantData) return false;

    const laStock = variantData.la_stock;
    if (laStock === null || typeof laStock === 'undefined' || laStock === '') return false;

    const la = parseInt(laStock, 10);
    const total = parseInt(variantData.inventory_quantity, 10);
    if (isNaN(la) || isNaN(total)) return false;
    if (la !== 0 || total <= 0) return false;

    const euCountries = ['AL','AD','AT','BE','BA','BG','HR','CZ','DK','EE','FO','FI','FR','DE','GI','GR','GG','HU','IS','IE','IM','IT','LV','LI','LT','LU','MT','MD','MC','ME','NL','MK','NO','PL','PT','RO','SM','RS','SK','SI','ES','SE','CH','GB','VA','DZ','AM','CY','EG','GE','GP','LB','MQ','MA','RE','BL','TN','TR','UA'];
    const userCountry = (window.Shopify && window.Shopify.country) || '';
    return euCountries.indexOf(userCountry) === -1;
  }

  // Helper for restoring the default button text when the region override clears.
  getDefaultBuyText(btn, variantData) {
    // Standard Shopify add-to-cart button (rendered by snippets/buy-buttons.liquid)
    if (btn.classList.contains('product-form__submit')) {
      return 'Add to cart';
    }
    // Matsuda custom BUY button — variant-aware shipping_month from my_fields metafield
    const months = {1:'JAN',2:'FEB',3:'MAR',4:'APR',5:'MAY',6:'JUN',7:'JUL',8:'AUG',9:'SEP',10:'OCT',11:'NOV',12:'DEC'};
    const m = variantData && variantData.shipping_month ? parseInt(variantData.shipping_month, 10) : null;
    if (m && months[m]) return 'BUY | SHIPS MID-' + months[m];
    return 'BUY';
  }

  colorSwatchDefaultVariant(event) {
    let variant_id = event.target.getAttribute('data-variant-id');
    if(variant_id) {
      let variant = this.getVariantData().find((variant) => {
                      return variant.id == variant_id;
                    });
      this.currentVariant = variant;
      this.querySelectorAll('fieldset').forEach((element,index) => {
          let option_name = element.getAttribute('data-option');
          let varaint_opt_ele = element.querySelector('input[type="radio"][value="'+variant.options[index]+'"]');
          if(option_name === 'color') {
            varaint_opt_ele = element.querySelector('input[type="radio"][data-variant-id="'+variant_id+'"][value="'+variant.options[index]+'"]');
            console.log("ITS color");
          }
          console.log("Selected Option input", varaint_opt_ele);
          
          if(varaint_opt_ele) {
            varaint_opt_ele.checked = true;
            varaint_opt_ele.dispatchEvent(new Event("change"));
          }
          
      });
      this.color_has_multiple_lens = true;
    } else {
      this.color_has_multiple_lens = false;
    }
  }

  clickTheSelctedColor() {
    let allColorInput = this.querySelectorAll('fieldset[data-option="color"] input[name="Color"]');
    let allSizesInput = this.querySelectorAll('fieldset[data-option="size"] input[name="Size"]');
    if(allSizesInput.length > 1)  {
      let selectedColor = [...allColorInput].find(colorInput => colorInput.checked);
      selectedColor.dispatchEvent(new Event("change", { bubbles: true }));
    }
    
  }
  playVimeoVideo() {
    if(typeof Vimeo === 'undefined') {
      return false;
    }
    let currentPlayingVariantId = document.querySelector('.product-gallery__item.active').getAttribute('data-for-variant-id');
    let currentlyPlayingIframe = document.querySelector(`.variant-iframe-${currentPlayingVariantId}`)
    let iframeToPlay = document.querySelector(`.variant-iframe-${this.currentVariant.id}`)
    if(currentlyPlayingIframe) {
      let playingPlayer = new Vimeo.Player(currentlyPlayingIframe);
          playingPlayer.pause().catch(function(error) {
              console.error("Error pausing video:", error);
          });
    }

    if(iframeToPlay) {
      let playerToPlay = new Vimeo.Player(iframeToPlay);
          playerToPlay.play().catch(function(error) {
              console.error("Error playing video:", error);
          });
    }
    
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    if(this.color_has_multiple_lens === false) { // Otherwise Current variant is already set in colorSwatchDefaultVariant
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });  
    }
    

    if(typeof this.currentVariant !== "undefined") {
      window.currentVariant = this.currentVariant;
    } else {
      this.currentVariant = window.currentVariant;
    }
    
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    
    if (tagName === 'SELECT' && target.selectedOptions.length) {
        const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
        
        const selectedDropdownSwatchValues = document.querySelectorAll(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
        if (!selectedDropdownSwatchValues.length) return;
        selectedDropdownSwatchValues.forEach(selectedDropdownSwatchValue => {
            if (swatchValue) {
                selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
                selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
            } else {
                selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
                selectedDropdownSwatchValue.classList.add('swatch--unavailable');
            }
        });
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      
        const selectedSwatchValues = document.querySelectorAll(`[data-selected-swatch-value="${name}"]`);
        if (selectedSwatchValues.length) {
            selectedSwatchValues.forEach(selectedSwatchValue => {
                selectedSwatchValue.innerHTML = value;
            });
        }
    }
    if(name === 'Color') {
      this.selectDefaultVariantForColor();
    }
  }

  selectDefaultVariantForColor() {
    const _variantMeta = window[`variants_${window.product?.id}`] || {};
    const _isSizeHidden = (v) => !!_variantMeta[v.id]?.hide_size_variant;

    let selectedOptionOneVariant = this.variantData.find(
      (variant) => this.querySelector(':checked').value === variant.option1 && variant.available === true && !_isSizeHidden(variant)
    );
    if(!selectedOptionOneVariant) {
      selectedOptionOneVariant = this.variantData.find(
        (variant) => this.querySelector(':checked').value === variant.option1 && !_isSizeHidden(variant)
      );
    }

    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    
    inputWrappers.forEach((option, index) => {
      if (index === 0) return; // SKIP the COLOR
      const valueToChoose = selectedOptionOneVariant.options[index];
      const optionInputs = option.querySelectorAll('input[type="radio"][value="'+valueToChoose+'"]');
      if(optionInputs.length && typeof optionInputs[0] !== undefined) {
        optionInputs[0].checked = true;
      }

      let allOptionRadios = option.querySelectorAll('input[type="radio"]');
      if(option.getAttribute('data-option') === 'size' && allOptionRadios.length > 1) {
        let allSizesForCurrentColor = this.variantData.filter(
              (variant) => this.querySelector(':checked').value === variant.option1
          ).map(variant => variant.options[index]);
        option.querySelectorAll('input[type="radio"]').forEach(input => {
          if(allSizesForCurrentColor.includes(input.value)) {
            input.classList.remove('_na');
          } else {
            input.classList.add('_na');
          }
        })
      }
      
      // console.log(selectedOptionOneVariant.options[index], optionInputs)

    })

    //Re-calculations 
    this.updateOptions();
    this.updateMasterId();
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateGallery() {
    if (!this) {
      console.error('currentVariant is not defined');
      return;
    }
    if (!this.currentVariant) {
      console.error('currentVariant is not defined');
      this.currentVariant = window.currentVariant;
    }
    const variantIdString = this.currentVariant.id.toString();
    const productGallery = document.querySelector('product-gallery');
    const heroGallery = document.querySelector('hero-gallery')
    
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    const productInfo = productForms[0].closest('product-info');

    // Region override: treat the variant as unavailable for non-EU shoppers when LA stock is 0
    // and Provence has stock. Otherwise existing behaviour is preserved exactly.
    const _regionOverride = this.computeRegionOverrideForVariant(this.currentVariant);
    const _effectiveAvailable = this.currentVariant.available && !_regionOverride;

    if (_effectiveAvailable) {
      document.querySelectorAll('[data-submit-form]').forEach(btn => {
        btn.disabled = false;
      });
      document.querySelectorAll('[data-oos-button]').forEach(btn => {
        btn.disabled = true;
        btn.parentElement.setAttribute('hidden', true);
      })

    } else {
      document.querySelectorAll('[data-submit-form]').forEach(btn => {
        btn.disabled = true;
      });

      document.querySelectorAll('[data-oos-button]').forEach(btn => {
        btn.disabled = false;
        btn.parentElement.removeAttribute('hidden');
      })

    }

    const currentSize = this.currentVariant.options[1];
    const availableColors = [];

    window.product.variants
      // .filter((variant) => variant.available && variant.options[1] === currentSize)
      .filter((variant) => variant.available)
      .forEach((variant) => {
        availableColors.push(variant.options[0]);
      });

    //console.log('Available Colors:', availableColors);

    const colorInputs = document.querySelectorAll('input[name="Color"]');

    colorInputs.forEach(input => {
        const parentLabel = input.parentElement;
        const colorValue = input.value;
        let has_variant_id = input.getAttribute('data-variant-id');
        
        // In case color is avialable in more one lens, we are rendering all color lens version
        // with their variant id. 
        if(has_variant_id) {
            let variant = this.getVariantData().find((variant) => {
                      return variant.id == has_variant_id;
                    });
            const regionOOS = this.computeRegionOverrideForVariant(variant);
            if(variant.available && !regionOOS) {
              input.classList.remove('disabled');
            } else {
              input.classList.add('disabled');
            }
        } else {
          if (!availableColors.includes(colorValue)) {
              input.classList.add('disabled');
          } else {
            const colorVariant = window.product && window.product.variants && window.product.variants.find(v => v.option1 === colorValue && v.available);
            const regionOOS = colorVariant ? this.computeRegionOverrideForVariant(colorVariant) : false;
            if (regionOOS) {
              input.classList.add('disabled');
            } else {
              input.classList.remove('disabled');
            }
          }
        }
        
    });

    if (!productGallery) {
        return; // Exit if product-gallery element is not found
    }

    // Check if the container for the current variant is already rendered
    const containers = document.querySelectorAll('.product-gallery__item');
    containers.forEach(container => {
        const itemVariantId = container.getAttribute('data-for-variant-id');
        if (itemVariantId === variantIdString) {
            // Show the container for the current variant
            container.classList.add('active');
        } else {
            // Hide containers for unrelated variants
            container.classList.remove('active');
        }
    });

    if (!window.renderedVariantIds.includes(variantIdString)) {
        
        // Update renderedVariantIds array
        window.renderedVariantIds.push(variantIdString);

        // If container not rendered, render it
        const variantHtml = window.variantContainer[variantIdString];
        const heroGalleryHtml = window.heroGallery[variantIdString];
        productGallery.innerHTML += variantHtml;
        heroGallery.insertAdjacentHTML('beforeend', heroGalleryHtml);
    }

    const productFitElements = document.querySelectorAll('[data-product-fit]');
    const productLensElements = document.querySelectorAll('[data-selected-swatch-lens]');
    const productEyeDimensionElements = document.querySelectorAll('[data-product-eye]');
    const productBridgeDimensionElements = document.querySelectorAll('[data-product-bridge]');
    const productTempleDimensionElements = document.querySelectorAll('[data-product-temple]');
    let lensOptionIndex = 1;
    this.querySelectorAll('.product-form__input').forEach((element, index) => {
      if(element.getAttribute('data-option') === 'lens') {
        lensOptionIndex = index;  
      }
    })
    
    productFitElements.forEach(productFitElement => {
        if(typeof window.fitWidth[this.currentVariant.id] === 'undefined') {
          window.fitWidth[this.currentVariant.id] = 0;
        }
        if (window.fitWidth[this.currentVariant.id] < 133) {
            productFitElement.innerHTML = 'Narrow';
        } else if (window.fitWidth[this.currentVariant.id] < 148) {
            productFitElement.innerHTML = 'Standard';
        } else {
            productFitElement.innerHTML = 'Wide';
        }
    });
    productLensElements.forEach(productLensElement => {
        productLensElement.innerHTML = this.currentVariant.options[lensOptionIndex];
    });
    
    if(typeof window.dimensions[this.currentVariant.id] !== 'undefined') {
      productEyeDimensionElements.forEach(productEyeDimensionElement => {
          productEyeDimensionElement.innerHTML = window.dimensions[this.currentVariant.id].eye;
      });
      
      productBridgeDimensionElements.forEach(productBridgeDimensionElement => {
          productBridgeDimensionElement.innerHTML = window.dimensions[this.currentVariant.id].bridge;
      });
      
      productTempleDimensionElements.forEach(productTempleDimensionElement => {
          productTempleDimensionElement.innerHTML = window.dimensions[this.currentVariant.id].temple;
      });
    }
    

    const swatchContainer = document.querySelector('.product-form__input--swatch');
    const checkedColorInput = swatchContainer.querySelector('input[name="Color"]:checked');
    const siblingLabel = checkedColorInput.nextElementSibling;
    const imageSrc = siblingLabel.querySelector('img').src;
    const productStickyImageContainer = document.querySelector('.product-sticky-atc__image');
    const productStickyImage = productStickyImageContainer.querySelector('img');
    const variantImageWrapper = document.querySelectorAll('[data-variant-image-wrapper] img')
    productStickyImage.src = imageSrc;

    variantImageWrapper.forEach(img => {
      img.src = imageSrc;
      img.srcset = ' ';
    });
  }

  initFlickitySlider() {
    if(typeof Flickity === 'undefined') {
      console.error("Unable to initialize gallery slider, Flickity is undefined")
      return false;
    }
    var elem = document.querySelector('.product-gallery__item.active .product-gallery__mobile-slider:not(.flickity-enabled)');
    if(elem) {
      window.current_pdp_flkty = new Flickity( elem, {
          cellAlign: 'left',
          contain: true,
          prevNextButtons: false,
          watchCSS: true,
          fullscreen: true,
          imagesLoaded: true
      });  
      console.log("Gallery init GLOBAL");
    }
    setTimeout(() => {
      let flkty = Flickity.data('.product-gallery__item.active .product-gallery__mobile-slider');
      if (flkty) {
        window.current_pdp_flkty = flkty;
        flkty.resize();
        console.log('flkty resized GLOBAL')
      }
    }, 500);
  }
  updateProductTitleBadge() {

    let productMetaField = window['variants_' + product?.id];
    // PDP badge containers
    let desktopBadgeContainer = document.querySelector('.product__info-container .product__title--desktop');
    let mobileBadgeContainer = document.querySelector('.mobile__title-wrap .product-title__collections');


    if(productMetaField[this.currentVariant.id]) {      
      if(productMetaField[this.currentVariant.id]['variant_label']) {
        // Badge element for desktop and mobile
        let desktopBadgeElement = desktopBadgeContainer.querySelector('[data-role="v-badge"]');
        let mobileBadgeElement = mobileBadgeContainer.querySelector('[data-role="v-badge"]');

        let v__label = productMetaField[this.currentVariant.id]['variant_label'];
        let v__labelHtml = variantLabelTemplate(v__label);
        if(v__label.indexOf("-") !== -1) {
          v__labelHtml = variantLabelTemplate(v__label.split("-")[0], v__label.split("-")[1]);
        }

        // Update/rempove badge for desktop
        if(desktopBadgeElement) {
          desktopBadgeElement.outerHTML = v__labelHtml
        } else {
          desktopBadgeContainer.insertAdjacentHTML('beforeend', v__labelHtml);
        }
        // Update/rempove badge for mobile
        if(mobileBadgeElement) {
          mobileBadgeElement.outerHTML = v__labelHtml
        } else {
          mobileBadgeElement.insertAdjacentHTML('beforeend', v__labelHtml);
        }

      } else {
        desktopBadgeContainer.querySelector('[data-role="v-badge"]')?.classList?.add('hidden');
        mobileBadgeContainer.querySelector('[data-role="v-badge"]')?.classList?.add('hidden');
      }

    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        // A variant that only has stock at Provence is not buyable outside Europe, so it
        // must not leave the size pill enabled — the same check the buy button already uses.
        .filter((variant) => variant.available && !this.computeRegionOverrideForVariant(variant) && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    // console.log('setInputavailability');
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);
      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      document.querySelectorAll('[data-submit-form]').forEach(btn => {
        btn.disabled = true;
      });
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      document.querySelectorAll('[data-submit-form]').forEach(btn => {
        btn.disabled = false;
      });
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

if (!customElements.get('modal-button')) {
  customElements.define('modal-button', class ModalButton extends HTMLElement {
      constructor() {
          super();
          this.button = this.querySelector('button')
          this.target = this.button.getAttribute('target');
          this.target_element = document.getElementById(`${this.target}`);
          this.close_element = document.querySelectorAll(`[action="close"][target="${this.target}"]`);
          this.action = this.button.getAttribute('action');
          this.type = this.button.getAttribute('type');
          this.close_listener = this.closeEsc.bind(this);

          this.form = this.target_element.querySelector('.rm-oos__fields');
          this.submit_status = this.target_element.querySelector('.rm-oos__thankyou');
          this.image_ele = this.target_element.querySelector('.rm-oos__image  img');
          this.init();
      }
      init() {
          this.button.addEventListener('click', this.toggle.bind(this));
          this.button.addEventListener('keydown', this.toggle.bind(this))
          this.close_element.forEach((button) => {
              button.addEventListener('click', this.close.bind(this));
          });
          if (this.type != "template") {
              this.initTargetListeners();
          } else {
              this.content = this.querySelector('template');
          }
      }
      initTargetListeners() {
          this.target_element.addEventListener('click', (event)=> { //target element is modal backdrop
              if (event.currentTarget == event.target) {
                  this.close();
              }
          })
          document.addEventListener('keydown', this.close_listener);
          this.close_listener = this.target_element.addEventListener('keydown', this.closeEsc.bind(this));
      }
      toggle(event) {
        if  (event.key != undefined && event.key !== "Enter") {
            return
        }
        if (event.key != undefined && event.key === "Enter") {
          event.preventDefault();
        }
        if (this.action == "toggle") {
            if (this.target_element.classList.contains('modal-show')) {
                this.close();
            } else {
                this.open();
            }
        } else {
            this.open();
        }
      }
      open() {
        this.updateVariantContent();
        this.form.style.display = "block";
        this.submit_status.style.display = "none";
        document.querySelector('body').classList.add('modal-open');
        if (this.type != "template") {
            this.target_element.classList.add('modal-show');
        } else {
            this.initModal();
        }
      }
      close() {
        document.querySelector('body').classList.remove('modal-open');
        this.target_element.classList.remove('modal-show');
      }
      closeEsc(event) {
        if (event.key === undefined) return
        if  (event.key != undefined && event.key !== "Escape") {
            return
        }
        this.close();
        if (this.type == "template") {
            document.removeEventListener('click', this.close_listener);
        }
      }
      focusTrap() {
          let interactable_elements = this.target_element.querySelectorAll('a,button');
          if (interactable_elements.length > 0) {
              interactable_elements[interactable_elements.length - 1].addEventListener('keydown', (event)=> {
                  if (event.key == "Tab") {
                      event.preventDefault();
                      interactable_elements[0].focus();
                  }
              })
          }
      }
      updateVariantContent() {
        if(window.currentVariant && this.image_ele) {
            this.image_ele.setAttribute('src', window.currentVariant.featured_image.src);
            this.image_ele.removeAttribute('srcset');
        }

        let meta = Shopify.getCurrentProductMetafields();
        if(this.button.getAttribute('data-oos-button') !== null) { // Out of stock modal
          let modal_type = meta.modal_type;
          let heading_ele = this.target_element.querySelector('.rm-oos__header > strong');
          let thankyou_ele = this.target_element.querySelector('.rm-oos__thankyou > span');
          let image_ele_wrap = this.target_element.querySelector('.rm-oos__image');
          let product_detail_wrap = this.target_element.querySelector('.rm-oos__variant-details');
          let product_vid_wrap = this.target_element.querySelector('.rm-oos__video');
          let modal_heading = Shopify.oos_modal.ncb_heading;
          let modal_thankyou_message = Shopify.oos_modal.ncb_message;
          if(['Back in Stock','Back to Stock'].some(status => meta.modal_type?.includes(status))) {
              modal_heading = Shopify.oos_modal.bis_heading.replace('{STYLE}', product.title);
              image_ele_wrap?.classList?.remove('hidden');
              product_detail_wrap?.classList?.remove('hidden');
              product_vid_wrap?.classList?.add('hidden');
              modal_thankyou_message = Shopify.oos_modal.bis_message;
          } else {
              image_ele_wrap?.classList?.add('hidden');
              product_detail_wrap?.classList?.add('hidden');
              product_vid_wrap?.classList?.remove('hidden');
              if(typeof Vimeo !== 'undefined' && document.getElementById('modal_video_product')) {
                setTimeout(()=>{ 
                      var iframe = document.getElementById('modal_video_product');
                        var player = new Vimeo.Player(iframe);
                        player.play();
                }, 100);  
              }
              
          }
          // --> BOF TMP code for '2809H-V2' only as per client request
          // Clients wants to show Variant image in OOS modal instead of video for this specific product
          if(product?.title === '2809H-V2') { 
              image_ele_wrap?.classList?.remove('hidden');
              product_detail_wrap?.classList?.remove('hidden');
              product_vid_wrap?.classList?.add('hidden');
          }
          // EOF TMP code for '2809H-V2' only as per client request <----

          if(typeof meta.bis_modal_heading !== 'undefined' && meta.bis_modal_heading.length) {
            modal_heading = meta.bis_modal_heading;
          }

          
          if(heading_ele) {
            heading_ele.innerHTML = modal_heading;
          }
          if(thankyou_ele) {
            thankyou_ele.innerHTML = modal_thankyou_message;
          }
        }

      }
  })
}

customElements.define('rm-oos', class extends HTMLFormElement {
  constructor() {
      super();
      this.container = this.closest('.custom-modal__content');
      this.form = this.container.querySelector('.rm-oos__fields');
      this.submit_status = this.container.querySelector('.rm-oos__thankyou');
      this.main_form_id = this.querySelector('[name="email"]').getAttribute('id').replace('-email', '');
      this.main_form = document.getElementById(this.main_form_id);
      this.addEventListener('submit', this.submitHandle.bind(this));
  }

  submitHandle(event) {
    event.preventDefault();
    const formData = new FormData(this);
    if (this.validateEmail(formData.get('email'))) {
      console.log('valid email')
      this.submitKlaviyo(formData.get('email'), formData);
    } else {
      this.querySelector('.rm-oos__field-error').style.display = "flex";
    }
  }
  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
  fetchJSONP(url) {
    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        const callbackFunction = "jsonpCallback_" + Math.random().toString(36).substr(2, 5);

        // Define the callback function dynamically
        window[callbackFunction] = (data) => {
            resolve(data); // Resolve the promise with received data
            document.body.removeChild(script);
            delete window[callbackFunction]; // Clean up
        };

        // Handle script loading errors
        script.onerror = () => {
            reject(new Error(`JSONP request to ${url} failed`));
            document.body.removeChild(script);
            delete window[callbackFunction];
        };

        // Append callback parameter to the URL
        script.src = `${url}${url.includes("?") ? "&" : "?"}callback=${callbackFunction}`;
        document.body.appendChild(script);
    });
  }
  submitKlaviyo(email, formData) {
    let main_form_data = new FormData(this.main_form);
    let product_id = main_form_data.get('product-id')
    let variant_id = main_form_data.get('id')
    //let subscribe = formData.get('subscribe') === "on" ? true : false;

    // console.log(product_id + " : " + variant_id + " : " + subscribe)

    const _bisCountry = (window.Shopify && window.Shopify.country) || '';
    const _bisEuCountries = ['AL','AD','AT','BE','BA','BG','HR','CZ','DK','EE','FO','FI','FR','DE','GI','GR','GG','HU','IS','IE','IM','IT','LV','LI','LT','LU','MT','MD','MC','ME','NL','MK','NO','PL','PT','RO','SM','RS','SK','SI','ES','SE','CH','GB','VA','DZ','AM','CY','EG','GE','GP','LB','MQ','MA','RE','BL','TN','TR','UA'];
    const _bisRegion = _bisEuCountries.indexOf(_bisCountry) !== -1 ? 'EU' : 'US';

    // Update profile with region properties separately — the BIS endpoint does not accept
    // custom properties inline, so we push them via the profiles endpoint first.
    fetch(`https://a.klaviyo.com/client/profiles?company_id=B45s8D`, {
      method: 'POST',
      headers: {
        revision: '2025-01-15',
        accept: 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json'
      },
      body: JSON.stringify({
        data: {
          type: 'profile',
          attributes: {
            email: email,
            properties: {
              country: _bisCountry,
              bis_region: _bisRegion,
              ...(_bisRegion === 'US'
                    ? { bis_la_variant_id: String(variant_id) }
                    : { bis_eu_variant_id: String(variant_id) })
            }
          }
        }
      })
    });

    var requestOptions = {
      method: 'POST',
      headers: {
        revision: '2025-01-15',
        accept: 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json'
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variant_id}`
              }
            }
          }
        }
      })
    };
    fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=B45s8D",requestOptions)
    .then((response) =>  {
      console.log("success")
      console.log(response)
      // Multi-variant append via the signed App Proxy. Best-effort: the single-value baseline
      // written above already covers a failure here (auto-degrade to single-variant).
      fetch(`/apps/bis-sync?email=${encodeURIComponent(email)}&variant_id=${encodeURIComponent(variant_id)}&region=${_bisRegion}`)
        .then(r => r.json())
        .catch(() => {})
        .finally(() => {
          this.form.style.display = "none";
          this.submit_status.style.display = "block";
        });

    })
    .catch(error => {
      this.querySelector('.rm-oos__field-error').style.display = "flex";
      console.error(err);
    });

  }
 
}, {extends: 'form'});

if (navigator.userAgent.includes("Mac OS X")) {
  document.documentElement.classList.add("macos");
}